module.exports = "pegasus/assets/frame-facebook.png";